// Classificador dos 5 buckets do Painel de Status — mutuamente exclusivos. A validação de
// dados segue a regra única de src/lib/validacaoDados.ts (03/11/2026): "Em validação de
// dados" é a fila da analista (termo assinado) e "Com pendência" é quem ela já analisou e
// espera o cliente (termo em análise). Antes a fila caía em "Outros" e a pendência saía
// da última decisão, mesmo depois de a negociação voltar para a fila.
import { isEffectivelyAtOrAfter } from '../../../src/lib/funnelUtils';
import { situacaoNaValidacao } from '../../../src/lib/validacaoDados';
import { NegRow, StatusBucket } from './types';

export function statusPanelBucket(r: NegRow): StatusBucket {
    const naValidacao = situacaoNaValidacao(r.status);
    if (naValidacao === 'fila') return 'em_analise';
    if (naValidacao === 'pendencia') return 'com_pendencia';
    if (isEffectivelyAtOrAfter(r, 'termo_aprovado')) return 'aprovados';
    if (r.status === 'termo_reprovado') return 'reprovados';
    return 'outros';
}
